import { timeout } from '@/shared/lib/utils/timeout';

export const leaveNewsToNews = (): Promise<void> => timeout(300).then(() => Promise.resolve());
